import { Button, type ButtonProps } from "@bookingcom/bui-react";
import { ArrowNavDownIcon } from "@bookingcom/bui-assets-react/streamline";
import styles from "../CampaignImpact.module.css";

type PeriodPickerTriggerProps = {
  text: string;
} & Pick<ButtonProps, "attributes">;

export const PeriodPickerTrigger = ({ text, attributes }: PeriodPickerTriggerProps) => {
  return (
    <Button
      variant="secondary-neutral"
      icon={ArrowNavDownIcon}
      iconPosition="end"
      ariaLabel="Select period"
      className={styles.periodPickerTrigger}
      attributes={attributes}
    >
      {text}
    </Button>
  );
};
